import styled from "styled-components";

export const Container = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.white};
  `}

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  padding: 4rem 3.2rem;
  width: 49.5rem;
`;

export const Subtitle = styled.h2`
  ${({ theme }) => `
    color: ${theme.colors.primaryBlue};
  `}
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 0;
`;

export const Title = styled.h1`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};
  `}
  font-size: 2.4rem;
  font-weight: 800;
  margin-bottom: 3.6rem;
  margin-top: 0.5rem;
`;

export const SectionTitle = styled.h3`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody + theme.transparencies.p30};
  `}
  font-size: 1.4rem;
  font-weight: 700;
`;

export const Paragraph = styled.p`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};
  `}
  font-size: 1.4rem;
  font-weight: 500;
  overflow-wrap: break-word;
  max-height: 50vh;
  overflow-y: auto;
  @media (max-height: 855px) {
    max-height: 40vh;
  }
  @media (max-height: 715px) {
    max-height: 30vh;
  }
  @media (max-height: 600px) {
    max-height: 20vh;
  }
`;

export const PdfContainer = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};
  `}
  align-items: center;
  border-radius: 0.8rem;
  box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.4);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  font-size: 1.4rem;
  font-weight: 600;
  height: 5rem;
  justify-content: space-between;
  margin: 0.4rem 0;
  padding: 1.5rem 1.7rem;
  width: 43.1rem;

  & > div {
    align-items: center;
    display: flex;
    & > p {
      margin: 0;
      padding: 0;
    }

    & > img {
      height: 2.5rem;
      margin-right: 1.4rem;
      width: 2rem;
    }
  }

  & > img {
    height: 1.7rem;
    width: 1.6rem;
  }
`;

export const PdfsContainer = styled.div`
  box-sizing: border-box;
  margin-bottom: 3.6rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  [disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
  }
`;
export const DivContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ButtonsContainerRed = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TitleCreditLine = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};
  `}
  flex-grow: 0;
  flex: none;
  font-family: Montserrat;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2rem;
  order: 0;
`;

export const ContainerBetween = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  .icon-loading {
    height: 6rem;
    width: 6rem;
  }
  .icon-error {
    height: 2.5rem;
    width: 2.5rem;
  }
`;

export const DivFlexCenter = styled.div`
  display: flex;
  justify-content: center;
  .icon {
    height: 7rem;
    width: 7rem;
  }
`;
export const DivRucConsigne = styled.div`
  display: flex;
  font-family: Montserrat;
  font-size: 1.5rem;
  margin-top: 2rem;
`;

export const ULRestrictedCodes = styled.ul`
  overflow-y: auto;
  max-height: 30vh;
  list-style-type: none;
  margin: 1rem 0;
  padding: 0;
  font-family: Montserrat;
  font-size: 1.5rem;
  font-style: normal;
  line-height: 3rem;
`;

export const LiRestricedCode = styled.li`
  list-style-type: none;
  margin-left: 0;
  padding-left: 0;
`;
